/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { AwvApi } from "client";
import { useUserContext } from "context/UserContext";
import { Const } from "const";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";

export const useGetAwvData = (frameTypeAndNumber?: string) => {
  const { jobsite } = useUserContext();

  const [awvApi, cancelAwvApi] = useApiWithTimeout(
    AwvApi,
    Const.operationTimeout.getAwvInfoList
  );
  return useCallApi(
    async () => {
      if (jobsite?.jobSiteId) {
        return awvApi.getAWVInfo({
          jobSiteId: jobsite.jobSiteId,
          frameTypeAndNumber: frameTypeAndNumber,
        });
      } else {
        throw new Error("jobsite not selected.");
      }
    },
    cancelAwvApi,
    [awvApi, cancelAwvApi, jobsite?.jobSiteId, frameTypeAndNumber]
  );
};
